import React from 'react'
import MainLayout from '@layouts/main-layout'
import Head from '@modules/common/components/head'
import WarrantyDirect from '@components/warranty-direct'

const WarrantyDirectPage = () => {
  return (
    <>
      <WarrantyDirect />
    </>
  )
}

WarrantyDirectPage.getLayout = (page: React.ReactElement) => {
  return (
    <MainLayout>
      <Head />
      {page}
    </MainLayout>
  )
}

export default WarrantyDirectPage
